
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The Core page header gives context and confidence to the user so they
  understand what the page is about. It is present on every page, to be placed
  just below the Site header.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Core/core-page-header.png" alt="Anatomy of core page header" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Components`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/components/navigation/breadcrumb/usage/" standalone mdxType="Link">{`Breadcrumb`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Breadcrumb component provides information on the page and its relationship to the site's hierarchy and structure`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Meta`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Metadata related to the content of the page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Page title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Title of the page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Introduction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Short description of the page`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`NOTE`}</strong>{`: Follow components' links above for individual information and guidelines`}</p>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`ensure the pages contain all the elements in the anatomy table above`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`don't use more than one Page header per page`}</li>
      <li parentName="ul">{`don't use it on the Homepage, use a `}<Link to="/ec/components/banners/page-banner/usage/" mdxType="Link">{`Page banner`}</Link>{` instead`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`always use a Page header when building your page`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not follow these guidelines when you are updating sites that fall under the `}<Link to="/ec/standardised-template/" mdxType="Link">{`Standardised`}</Link>{` or `}<Link to="/ec/harmonised-templates/group1/" mdxType="Link">{`Harmonised`}</Link>{` category`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;